import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ROUTE_PATH, LOCAL_STORAGE } from '../../data/config/constants';
import { isModuleAccessible, isActionPermitted, isEventPermitted, log } from '../../data/config/utils';

import ShowMessage from '../showmessage';

const PrivateRoute = ({ component: Component, permissions: permissions, token: token, admin_id: admin_id, parent_path: parent_path, is_permitted: is_permitted, ...rest }) => {
  log('private route rendered')
  return (
    <Route
      {...rest}
      render={
        (props) => {
          if (token && admin_id) {
            const is_module_allowed = parent_path ? isModuleAccessible(permissions, props.match.path, parent_path) : isModuleAccessible(permissions, props.match.path);
            if (is_permitted || is_module_allowed) {
              return (
                <Component {...props} isActionPermitted={(key, action) => isActionPermitted(permissions, key, action)} isEventPermitted={(key) => isEventPermitted(permissions, key)} />
              );
            } else {
              return (
                <ShowMessage error show_button title="403" message="you don't have privileges to access with this credentials, you can contact your administrator." handleButtonClick={() => props.history.goBack()} />
              );
            }
          } else {
            localStorage.removeItem(LOCAL_STORAGE.ORI_ADMIN);
            return (
              <Redirect to={{ pathname: ROUTE_PATH.LOGIN, state: { from: props.location } }} />
            );
          }
        }
      }
    />
  );
}

const mapStateToProps = state => {
  return {
    permissions: state.admin_details.user_info && state.admin_details.user_info.permissions ? state.admin_details.user_info.permissions : null,
    admin_id: state.admin_details.admin_id,
    token: state.admin_details.token
  };
};

PrivateRoute.propTypes = {
  component: PropTypes.func,
  location: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  is_permitted: PropTypes.bool,
  permissions: PropTypes.object,
  token: PropTypes.string,
  admin_id: PropTypes.string,
  isActionPermitted: PropTypes.func,
  parent_path: PropTypes.string,
}

PrivateRoute.defaultProps = {
  is_permitted: false,
}

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/privateroute/index.js